import Strings from "@my-dld/assets/strings";
import { LocaleUtil, StringUtil } from "@eres/core";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { hideLoading, showErrorMessage, showLoading } from "./UIUtils";
import { getParticipantID } from "@10x/sso";
import { ITabuSmartService, TabuRequestApi, TabuRequestUtils, TabuUtils } from "@10x/tabu-mobile-api";
import { Entities as REntities, PropertySvcApi } from "@10x/dubai-rest-api";
import { sanitizeTabuMobileDocumentUrlNext } from "./UrlUtils";
import { trackEventWithData } from "./Analytics";
import { ServiceCard } from "@my-dld/components/ServiceContainer";
import ServiceDescriptions from "@my-dld/assets/strings/property_serv_desc";

export enum TabuPropertyType {
	LAND = 1,
	VILLA = 2,
	UNIT = 3,
	BUILDING = 4,
}

export enum EjariPropertyType {
	VILLA = 4,
	UNIT = 2,
	LAND = 0,
	BUILDING = 1,
	COMPOUND = 3,
	VIRTUAL_VILLA = 5,
}


export function getPropertyType( propertyTypeID: number ): string {
	switch ( propertyTypeID ) {
		case TabuPropertyType.LAND :
			return Strings.land;
		case TabuPropertyType.BUILDING :
			return Strings.building;
		case TabuPropertyType.UNIT :
			return Strings.unit;
		case TabuPropertyType.VILLA :
			return Strings.villa;
		default:
			return "";
	}
}

export function getVillaName( property: AssetCard ): string {
	let val;
	val = ( property as any ).villaNumber;
	if ( !val ) {
		if ( property.title ) {
			return getVillaNameByTitle( property.title );
		}
	} else if ( StringUtil.isEmptyStringOrNull( val ) ) val = "";
	return val;
}

export function getUnitNumber( property: AssetCard ): string {
	let val = ( property as any ).unitNumber;
	if ( !val ) {
		if ( property.title ) {
			return getUnitNumberByTitle( property.title );
		} else if ( StringUtil.isEmptyStringOrNull( val ) ) val = "";
	}
	return val;
}

export function downloadCertificate( property: AssetCard ) {
	showLoading();
	trackEventWithData( "Property", "DownloadCertificate", { type: property.propertyTypeId, id: property.propertyId } );
	TabuRequestApi.getElectronicTitleDeed( getParticipantID() + "", property.propertyId + "", "" )
	.then( TabuUtils.validateResponse )
	.then( x => {
		hideLoading();
		if ( x.Certificate && x.Certificate.length > 0 ) {
			let url = x.Certificate[ 0 ].FileName;
			if ( url ) {
				sanitizeTabuMobileDocumentUrlNext(url);
				// window.open( sanitizeTabuMobileDocumentUrl( url ) );
			}
		}
	} )
	.catch( error => {
		hideLoading();
		showErrorMessage( error.toString() );
	} );
}

export function downloadSitePlan( property: AssetCard ) {
	showLoading();
	const id = property.propertyId + "";
	trackEventWithData( "Property", "DownloadSitePlanTry", { id: id } );
	TabuRequestApi.getSiteMap( id ).then( response => {
		hideLoading();
		if ( response.Code + "" === "0" ) {
			let res = response.Response;
			if ( res != null && res.MapImagePath != null && res.MapImagePath.length > 0 ) {
				let url = res.MapImagePath;
				trackEventWithData( "Property", "DownloadSitePlan", { id: id } );
				// if (url) {
				// 	let a = document.createElement( "a" );
				// 	a.href = url;
				// 	a.download = url;
				// 	a.click();
				// 	hideLoading();
				// }
				if ( url ) sanitizeTabuMobileDocumentUrlNext(url, {"mode":"no-cors"});
				// window.open( sanitizeTabuMobileDocumentUrl( url ) );
			} else {
				trackEventWithData( "Property", "DownloadSitePlanFailed", { id: id } );
				showErrorMessage( Strings.site_plan_unavailable );
			}
		} else {
			trackEventWithData( "Property", "DownloadSitePlanFailed", { id: id } );
			showErrorMessage( Strings.site_plan_unavailable );
		}
	} ).catch( ex => {
		hideLoading();
		showErrorMessage( ex.errorMessage ? ex.errorMessage : ex.toString() );
	} );
}

export function downloadSaleContract( property: AssetCard ) {
	showLoading();
	const id = property.propertyId + "";
	trackEventWithData( "Property", "DownloadSaleContractTry", { id: id } );
	PropertySvcApi.getSaleContract( id )
	.then( REntities.validateResponse )
	.then( x => {
		hideLoading();
		let url = x?.path;
		if ( url ) {
			if ( url.match( /http[s]*:\/\/ameentasjeel.ae/ ) ) {
				url = url.replace( /http[s]*:\/\/ameentasjeel.ae/, "https://ameentasjeel.dubailand.gov.ae" );
				trackEventWithData( "Property", "DownloadSaleContractURLRewrite", { id: id } );
			}
			trackEventWithData( "Property", "DownloadSaleContractURL", { id: id } );
			if ( url ) sanitizeTabuMobileDocumentUrlNext(url);
			// window.open( sanitizeTabuMobileDocumentUrl( url ) );
		} else {
			trackEventWithData( "Property", "DownloadSaleContractError", { id: id, e: "No Url" } );
			showErrorMessage( Strings.not_available );
		}
	} )
	.catch( error => {
		hideLoading();
		const em = error?.toString();
		trackEventWithData( "Property", "DownloadSaleContractError", { id: id, e: em } );
		showErrorMessage( em );
	} );
}

export function getVillaNameByTitle( title?: any ): string {
	if ( title ) {
		let t = LocaleUtil.getLocalValue( title, "en" );
		let r = t.match( /Building (.*) in/ );
		if ( r && r[ 1 ] ) {
			return r[ 1 ];
		}
	}
	return "";
}

export function getUnitNumberByTitle( title?: any ): string {
	if ( title ) {
		let t = LocaleUtil.getLocalValue( title, "en" );
		let r = t.match( /Unit (.*) in/ );
		if ( r && r[ 1 ] ) {
			return r[ 1 ];
		}
	}
	return "";
}

export function getLandNumberByTitle( title?: any ): string {
	if ( title ) {
		let t = LocaleUtil.getLocalValue( title, "en" );
		let r = t.match( /Land (.*) in/ );
		if ( r && r[ 1 ] ) {
			return r[ 1 ];
		}
	}
	return "";
}

export function isMultiOwner( data: AssetCard ) {
	return data.shareValue < 100;

}

const TabuFeatureMap: Record<string, string> = {
	bcs_reclassification: "bcsReclassification",
	ownership_change: "ownerShipChange",
	property_cut_off: "propertyCutOff",
	delayed_property_cut_off: "delayedPropertyCutOff",
	property_annex: "propertyAnnex",
	delayed_property_annex: "delayedPropertyAnnex",
};

export function convertTabuServiceToPropertyService(
	tabuSvc: ITabuSmartService, handleServiceAction: ( id: string ) => void, extra?: Partial<ServiceCard> ): ServiceCard {
	const svc = {
		id: TabuRequestUtils.tabuProcedureIdString( tabuSvc.Id ),
		label: tabuSvc.Name,
		action: handleServiceAction,
		descriptionProvider: ServiceDescriptions,
		allowUnverifiedEmailUsers: false,
		...extra,
	};
	if ( TabuFeatureMap[ svc.id ] ) {
		svc.requiredFeature = TabuFeatureMap[ svc.id ];
	}
	return svc;
}
